<template>
<!-- eslint-disable max-len -->
<div :class="{ allocation: true, native: (native), sf: (starfighter) }">
  <h1 class="budget-allocation-header">Budget Allocation</h1>
  <div class="objectives-performance-bar">
    <div class="objectives-performance-container">
      <h3 class="objectives-performance-header">Scoring Objectives</h3>
      <div>{{playerDecision.scoringObjective}}</div>
    </div>
    <div class="objectives-performance-container">
      <h3 class="objectives-performance-header">Key Performance Measures</h3>
      <div>{{playerDecision.keyPerformanceMeasure}}</div>
    </div>
  </div>
  <div>
    <div :class="{ native, sf: (starfighter) }" class="allocation-form">
      <budgets-bar style="width: 580px" id="allocation-total-budget" :totalBudget="totalBudget" :choices="choices" :colors="colors"></budgets-bar>

      <div class="allocation-budgets btn-white">
        <template v-if="!reset" >
          <div style="width: 100%; height: 70px;"
            v-for="(choice, i) in choices"
            :key="i"
          >
            <div>
              <choice-slider
                :idx="i"
                :choice="choice"
                :color="colors[i]"
                :total="totalBudget"
                :displayIntervals="playerDecision.sliderDisplayIntervals"
                :sliderInterval="playerDecision.sliderInterval"
                currency
                v-model="choice.allocation"
                :slider-interval="100"
                title-align="left"
                title-height="18px"
                :slider-min="0"
                :slider-max="availableBudgets[i]"
                :focus="i === 0"
                :tabindex="i + 1"
                :title="getChoiceLabel(choice)"
                display-value-on-top
                not-rounded
                slider-style="box-shadow: 0px 2px 5px rgba(0,0,0,0.5); height: 18px; margin-top: 5px; border: 0px solid transparent !important;"
                width="550px"
              />
              <b-btn @click="()=> selectedChoiceIdx = i" :class="`btn ${selectedChoiceIdx == i ? 'selected' : 'deselected'}`" style="font-size: 20px; margin-top: 5px; margin-left: 560px; height: 40px; line-height: 20px; width: 130px;">Details</b-btn>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="allocation-detail">
      <template v-if="playerDecision.type === 'roleAllocation'">
        <template v-if="selectedRoleAllocationPlayer">
          <div style="height: 64px; display: flex; justify-content: left;">
            <img class="character-icon" width="64" height="64" :src="resolveAssetPath(selectedRoleAllocationPlayer.character.icon, 'images')"/>
            <div style="margin-left: 10px;">
              <h3 style="margin-bottom: 0px;">{{selectedRoleAllocationPlayer.character.title}}</h3>
              <h4 style="font-size: 18px; margin-bottom: 5px;">{{selectedRoleAllocationPlayer.role.title}}</h4>
            </div>
          </div>

          <div v-html="selectedRoleAllocationPlayer.role.description"/>
        </template>
        <template v-else>
          Invalid player seleected
        </template>
      </template>
      <template v-else>
          <span v-html="activeDetailsText" />
          <div :style="`margin-top: 10px; outline: 1px solid white; width: 100%; height: 100%; background-size: cover; background-image: url(${resolveAssetPath(activeChoice.image, 'images')})`"
                v-if="activeChoice && activeChoice.image && activeChoice.image !== ''"
          />
      </template>
    </div>
  </div>
  <div class="allocation-controls">
    <button class="btn allocation-reset" @click.prevent="resetBudgets" :tabindex="choices.length + 1">Reset</button>
    <button class="btn allocation-submit" @click.prevent="submitBudgets" :tabindex="choices.length + 2">{{(game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next'}}</button>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

import Paragraphs from '../../ui/display/Paragraphs';
import BudgetsBar from './BudgetsBar';
import ChoiceSlider from './ChoiceSlider';
// import PercentSlider from './PercentSlider';

export default {
  props: {
    decision: { type: Object },
    colors: { type: Array },
    selectedChoices: { type: Array },
    hasSubmitted: { type: Boolean }
  },
  components: {
    Paragraphs,
    BudgetsBar,
    ChoiceSlider
  },
  data() {
    /*
    // This is just here as an easy way of testing how multiple entries render

    const choices = this.decision.choices.map(({ _id, title, description,
      image, allocateToRole }) =>
      ({
        _id,
        title,
        description,
        image,
        allocateToRole,
        allocation: 0
      }));

    for (let i = 0; i < 3; ++i) {
      choices.push(JSON.parse(JSON.stringify(choices[0])));
    }
    */

    return {
      selectedChoiceIdx: 0,
      totalBudget: 0,
      choices: this.decision.choices.map(({ _id, title, description, image, allocateToRole }) => ({
        _id,
        title,
        description,
        image,
        allocateToRole,
        allocation: 0
      })),
      reset: false
    };
  },
  computed: {
    ...mapGetters([
      'roles',
      'allPlayers',
      'cash',
      'playerDecision',
      'playerGroupRole',
      'game',
      'starfighter',
      'native'
    ]),
    availableBudgets() {
      const res = [];
      for (let i = 0; i < this.choices.length; ++i) {
        res[i] = this.availableBudget(i);
      }
      return res;
    },
    selectedRoleAllocationPlayer() {
      const choice = this.choices[this.selectedChoiceIdx];
      if (!choice) return null;

      // eslint-disable-next-line no-restricted-syntax
      for (const pl of this.allPlayers) {
        if (pl && pl.role && pl.role._id === choice.allocateToRole) {
          return pl;
        }
      }
    },
    activeChoice() {
      return this.choices[this.selectedChoiceIdx];
    },
    activeDetailsText() {
      const choice = this.choices[this.selectedChoiceIdx];
      if (!choice) return 'Invalid choice selected';

      if (this.playerDecision.type === 'roleAllocation') {
        return 'role allocation invalid, shouldn\'t be hitting this';
      } else if (this.playerDecision.type === 'projectAllocation') {
        return choice.description;
      }
      return 'unknown decision type';
    }
  },
  methods: {
    getChoiceLabel({ allocateToRole, title }) {
      switch (this.decision.type) {
        case 'projectAllocation':
          return title;
        case 'roleAllocation':
        {
          const role = this.roles[allocateToRole];
          return (role && role.title) || '???';
        }
        default: return '';
      }
    },
    availableBudget(choiceIndex) {
      const budgetUsedElsewhere = this.choices.reduce((acc, choice, i) => (
        acc + (i === choiceIndex ? 0 : choice.allocation)
      ), 0);
      return this.totalBudget - budgetUsedElsewhere;
    },
    async resetBudgets() {
      this.choices.forEach((choice) => {
        choice.allocation = 0;
      });
      // force re-render to handle enter key properly
      this.reset = true;
      await Vue.nextTick();
      this.reset = false;
    },
    async submitBudgets() {
      await new Promise(resolve => setTimeout(resolve, 250));
      const { choices, totalBudget } = this;
      this.$emit('input', { choices, totalBudget });
    }
  },
  created() {
    // TODO: make this generic to work with playedBy
    this.totalBudget =
      this.playerDecision.type === 'projectAllocation' ? ((this.playerGroupRole.useRoleCash && this.playerGroupRole.cash) || this.cash) || 0 :
        this.playerDecision.type === 'roleAllocation' ? this.cash || 0 :
          0;

    if (this.hasSubmitted) {
      // eslint-disable-next-line no-restricted-syntax
      for (let i = 0; i < this.choices.length; i++) {
        this.choices[i].allocation = this.selectedChoices[i].allocation;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.allocation {
  position: absolute;
  width: 1225px;
  height: 700px;
  padding: 20px;
  background-color: white;
}

.allocation.native
{
  display: flex;
  border: 25px solid rgba(0, 0, 0, 0);
  border-image: url('/static/ui/customer/B2_TextBox_90.png') 90 fill;
  transform: translateZ(0);
}

.allocation h2 {
  display: inline-block;
  width: 380px;
  height: auto;
  margin: 0 20px 0 0;
  float: left;
}

.allocation h2 img {
  width: 380px;
  height: 210px;
  margin-bottom: 15px;
  object-position: top left;
  object-fit: cover;
  border: 4px inset white;
}
.allocation h2 article {
  height: 430px;
  padding: 15px;
}
.allocation h2 article h1 {
  line-height: 36px;
  font-size: 32px;
  font-weight: bold;
  color: var(--primaryColor);
  overflow: auto;
  margin-bottom: 15px;
}
.allocation h2 article p {
  line-height: 32px;
  font-size: 28px;
  font-weight: bold;
  color: black;
  overflow: auto;
}
.allocation-description {
  overflow-y: auto;
}

.objectives-performance-bar {
  margin-top: 10px;
  margin-left: -20px;

  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: white;
  width: calc(100% + 40px);
  height: 100px;
  background-color: var(--allocationPerformanceBarBackgroundColor);
}

.objectives-performance-container {
  outline: 2px solid rgba(255, 255, 255, 0.4);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
  min-width: 45%;
}

.objectives-performance-header {
  margin-bottom: 2px;
}

.allocation-form {
  position: fixed;
  overflow-y: auto;
  background-color: transparent;
  width: 785px;
  height: 590px;
  margin-left: 0px;
}

.allocation-detail {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  padding: 30px;
  top: 350px;
  margin-left: 735px;
  background-color: var(--allocationActiveDetailsBackgroundColor);
  width: 430px;
  height: 340px;
  color: white;
}

.selected {
  background-color: var(--allocationActiveDetailsButtonColor) !important;
  box-shadow: 0px 3px 0px var(--allocationActiveDetailsButtonColor),
              0px 1px 6px rgba(0, 0, 0, 0.4),
              inset 0px 1px 0px rgba(255, 255, 255, 0.3),
              inset 0px 0px 3px rgba(255, 255, 255, 0.5)
              !important;

  // Setting this so that we can actually override the color
  background-image: -webkit-gradient(linear, left bottom, left top,
                    color-stop(0, var(--allocationActiveDetailsButtonColor)),
                    color-stop(1, var(--allocationActiveDetailsButtonColor)));
}

.deselected {
  background-color: var(--allocationInactiveDetailsButtonColor) !important;
  box-shadow: 0px 3px 0px var(--allocationInactiveDetailsButtonColor),
              0px 1px 6px rgba(0, 0, 0, 0.4),
              inset 0px 1px 0px rgba(255, 255, 255, 0.3),
              inset 0px 0px 3px rgba(255, 255, 255, 0.5)
              !important;

  // Setting this so that we can actually override the color
  background-image: -webkit-gradient(linear, left bottom, left top,
                    color-stop(0, var(--allocationInactiveDetailsButtonColor)),
                    color-stop(1, var(--allocationInactiveDetailsButtonColor)));
}

.bar-back {
  width: 100%;
  height: 35px;
  background-color: black;
  border: 3px solid var(--primaryColor);
  clear: both;
  display: inline-block;
}
.allocation-budgets {
  color: black;
  height: 280px;
  margin-bottom: 10px;
  padding: 0px 15px 10px 15px;
}
.allocation-controls {
  position: fixed;
  width: 760px;
  bottom: 90px;
  height: 95px;
  padding: 0px 0;
}
.allocation .btn {
  width: 250px;
  height: 80px;
  font-size: 44px;
  line-height: 44px;
}
.allocation-reset {
  float: left;
  height: 30px;
}
.allocation-submit {
  float: right;
}
.budget-allocation-header {
  font-weight: bolder;
}

.character-icon
{
  background-color: white;
  outline: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Allocation.vue